<template>
  <div class="create-contain">
    <div class="info-line">
      <div class="info-title-line" style="margin-bottom: 10px;">
        <div class="info-line-title">付款信息</div>
      </div>
      <div class="product-detail" v-for="(product, index) in productInfo.related_products" :key="index">
        <img class="img" :src="product.cover" />
        <div class="info">
          <div class="title">{{product.title}}</div>
          <div class="subtitle">{{product.description}}</div>
        </div>
        <div class="price">{{ product.original_price | priceFilter }}</div>
      </div>      
      <div class="bottom-border" />
      <div class="price-detail">
        <div class="price-line">
          <div class="price-title">商品总价：</div>
          <div class="price">{{ totalPrice | priceFilter }}</div>
        </div>
        <div class="price-line">
          <div class="price-title">活动优惠：</div>
          <div class="price">{{ discountPrice | priceFilter }}</div>
        </div>
        <div class="price-line">
          <div class="price-title">实付款：</div>
          <div class="price-num">
            {{ productInfo.real_price | priceFilter }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="product-info">
      <img class="product-pic" :src="productInfo.cover.small_cover" />
      <div class="product-info-context">
        <div class="product-title">{{ productInfo.title }}</div>
      </div>
    </div> -->
    <div class="blank-line"></div>
    <block v-if="haveHardPen">
      <div class="info-line">
        <div class="info-title-line">
          <div class="info-line-title">礼包信息</div>
          <div class="info-line-tip">用于定制礼包</div>
        </div>
        <div class="input-line">
          <div class="input-label">孩子名字</div>
          <van-field
            v-model.trim="child_nn"
            placeholder="请输入"
            class="long-input"
          />
        </div>
        <div class="bottom-border" />
        <div class="input-line">
          <div class="input-label-short input-label">课程级别</div>
          <div class="level-select" @click="$refs.levelSelecttDialog.show()">
            <span v-if="level">{{ levelName }}</span>
            <span style="color:#A7A4A1;" v-else>请选择</span>
          </div>
          <img :src="imgUrl + 'new/icon-arrow.png'" class="level-arrow" />
          <!-- <van-dropdown-menu>
            <van-dropdown-item v-model="level"
                               :options="levelList" />
          </van-dropdown-menu> -->
        </div>
      </div>
      <div class="blank-line"></div>
    </block>
    <div class="info-line">
      <block v-if="!needAddress">
        <div class="info-title-line">
          <div class="info-line-title">联系方式</div>
          <div class="info-line-tip">（便于联系核对信息）</div>
        </div>
        <div class="input-line">
          <div class="input-label">电话号：</div>
          <van-field
            v-model="userInfo.cellphone"
            placeholder="请输入您的手机号"
            class="long-input"
          />
        </div>
      </block>
      <block v-else>
        <div class="info-title-line">
          <div class="info-line-title">收货地址</div>
          <div class="info-line-tip">便于寄送学习大礼包，只需填写一次</div>
        </div>
        <div v-if="userInfo.address" class="address-info">
          <div class="address-info-content">
            <div class="address-info-content-top">
              <span>{{ userInfo.name }}</span>
              <span style="margin-left: 10px">{{ userInfo.cellphone }}</span>
            </div>
            <div class="address-info-content-bottom">
              {{ userInfo.address }}
            </div>
          </div>
          <div class="address-info-line"></div>
          <div class="address-info-btn" @click="editAddress">修改</div>
        </div>
        <div class="new-address" @click="editAddress" v-else>
          <img class="address-btn" :src="imgUrl + 'address-btn.png'" />
          <!-- <img class="add-icon" :src="imgUrl + 'add-icon.png'" />
          <div>添加收货地址</div> -->
        </div>
      </block>
    </div>
    <div class="blank-line"></div>
    <div class="info-line" style="margin: 0; padding-bottom: 15px">
      <div class="input-line" style="margin: 0; padding: 0">
        <div class="input-label" style="color: #3c3531">买家留言</div>
        <van-field
          v-model="note"
          placeholder="请输入（可不填）"
          class="long-input"
          :rows="1"
          autosize
          type="textarea"
          :maxlength="50"
        />
      </div>
    </div>
    <div class="blank-line"></div>

    <div class="info-line" style="margin-bottom: 60px;">
      <div class="info-title-line" style="margin-bottom: 3px">
        <div class="info-line-title">支付方式</div>
      </div>
      <div class="pay" @click="changePayMode('wxPay')">
        <div class="left">
          <img
            class="wx-icon"
            :src="aliURL + '/h5/mulit/art-product/imgs/wxpay.png'"
          />
          <span class="title">微信支付</span>
        </div>
        <img
          v-if="payMode == 'wxPay'"
          class="check"
          :src="imgUrl + 'new/check-active-v2.png'"
        />
        <div class="uncheck" v-else></div>
      </div>
      <div class="pay" @click="changePayMode('aliPay')">
        <div class="left">
          <img
            class="wx-icon"
            :src="aliURL + '/h5/mulit/art-product/imgs/alipay.png'"
          />
          <span class="title">支付宝支付</span>
        </div>
        <img
          v-if="payMode == 'aliPay'"
          class="check"
          :src="imgUrl + 'new/check-active-v2.png'"
        />
        <div class="uncheck" v-else></div>
      </div>
      <div class="pay" @click="changePayMode('hbfq')" v-show="isHbfq">
        <div class="left">
          <img
            class="wx-icon"
            :src="aliURL + '/h5/mulit/art-product/imgs/huabei.png'"
          />
          <span class="title"
            >花呗分期 <span class="hbfq-tip">{{ hbfqTip }}</span></span
          >
        </div>
        <img
          v-if="payMode == 'hbfq'"
          class="check"
          :src="imgUrl + 'new/check-active-v2.png'"
        />
        <div class="uncheck" v-else></div>
      </div>
      <div class="huabei" v-show="isHbfq">
        <template v-for="(item, index) in hbfqPrices">
          <div
            class="huabei-item"
            v-bind:class="{ active: item.active }"
            @click="changeHbfqNum(item.num)"
            :key="index"
          >
            <span class="price"
              >¥{{ (item.price + item.fee) / 100 }} × {{ item.num }}期</span
            >
            <span>含手续费¥{{ item.fee / 100 }}/期</span>
            <img
              v-if="item.recommend"
              class="recommend"
              :src="aliURL + '/h5/mulit/art-product/imgs/recommend.png'"
            />
          </div>
        </template>
      </div>
    </div>

    <div class="blank-line"></div>
    <div class="page-contain-bottom"></div>
    <div class="page-bottom1">
      <div class="img-box" @click="isAgreement = !isAgreement">
        <img
          :src="
            imgUrl +
            (isAgreement ? 'new/check-active-v2.png' : 'new/shop-check.png')
          "
        />
      </div>
      <span @click="goAgreement">我已阅读并同意《{{ lawLabel }}》</span>
    </div>
    <div class="page-bottom">
      <div class="bottom-price">{{ productInfo.real_price | priceFilter }}</div>
      <van-button class="pay-btn" @click="submitAddress">确认付款</van-button>
    </div>
    <!-- <div class="product-address"></div> -->
    <Dialog ref="refundDialog" :type="1" />
    <LevelSelectDialog ref="levelSelecttDialog" :levelList="levelList" :level="level" @setLevel="setLevel" />
  </div>
</template>
<script>
import ProductApi from "api/ProductApi";
import OrderApi from "api/OrderApi";
import UserApi from "api/UserApi";
import Dialog from "@/components/Dialog";
import LevelSelectDialog from "@/components/LevelSelectDialog";
import { getWxLocation } from "../mixin/weixin.js";
import { wexinPay } from "assets/enjory.js";
import aliPay from "assets/aliPay.js";
import wxPay from "assets/wxPay.js";
import roundHalfEven from "round-half-even";

export default {
  components: {
    Dialog,
    LevelSelectDialog,
  },
  data() {
    return {
      lawLabel: "河小象用户协议",
      lawUrl:
        "https://sc2.hexiaoxiang.com/app/hxx_protocol/HXXUserProtocol-Write.html", // 用户协议URL
      imgUrl: "https://sc2.hexiaoxiang.com/h5/purchase/img/",
      refundDialog: false,
      productInfo: {
        pay_info: {},
        cover: {},
      },
      cellphone: "",
      code: "",
      note: "",
      child_nn: "",
      level: 0,
      levelList: [
        { text: "启蒙（大班-小班）", value: 1 },
        { text: "低年级（1-3年级）", value: 2 },
        { text: "高年级（4年级及以上）", value: 3 },
      ],
      logisticsList: [
        "",
        ["", "XKQMB001", "XKDNJ001", "XKGNJ001"],
        "CB001",
        "RBLB001",
        "BC001",
        "",
        "YY001",
        "",
        "",
        "",
        "",
        "",
        "S2BNLB01",
        "",
        "GYSH001",
      ],
      userInfo: {},
      needAddress: false,
      haveHardPen: false,
      createOrderId: "",
      isAgreement: false,
      aliURL: "https://sc2.hexiaoxiang.com",
      productId: "",
      payMode: "",
      selectedHbfqNum: 0, //花呗分的期数
    };
  },
  created() {
    this.productId = this.$route.query.productId;
    this.getProductInfo();
    // const {child_nn, level} = this
    let formInfo = localStorage.getItem("form");
    formInfo &&
      typeof formInfo == "string" &&
      (formInfo = JSON.parse(formInfo));
    if (formInfo) {
      const { child_nn, level } = formInfo;
      this.child_nn = child_nn;
      this.level = level;
      localStorage.removeItem("form");
    }
  },
  computed: {
    levelName() {
      if (this.level) {
        let level = this.levelList.find((item) => {
          return item.value == this.level
        })

        return level.text
      }
    },
    totalPrice() {      
      let total = 0;
      if (this.productInfo && this.productInfo.related_products) {
        let rp = this.productInfo.related_products
        for (let i = 0; i < rp.length; i++) {
          total += rp[i].original_price
        }
      }
      return total
    },
    discountPrice() {
      return this.productInfo.real_price - this.totalPrice 
    },
    // 是否支持花呗分期
    isHbfq() {
      if (!this.productInfo || !this.productInfo.pay_info) {
        return false;
      }

      const { support_hb_fq } = this.productInfo.pay_info;
      return support_hb_fq == 1;
    },

    // 花呗分期每期价格，包含手续费
    hbfqPrices() {
      if (!this.isHbfq) {
        return;
      }

      let that = this;
      const { hb_fq_nums, fq_free_rate_nums } = this.productInfo.pay_info;
      let ary = [];
      if (hb_fq_nums && hb_fq_nums.length) {
        ary = hb_fq_nums.map((n) => {
          return {
            num: n,
            price: that.termPrice(n),
            fee: that.feePrice(n),
            active: that.selectedHbfqNum == n && that.payMode == "hbfq",
            recommend: fq_free_rate_nums.find((e) => {
              return e == n;
            }),
          };
        });
      }

      console.log(ary);
      return ary;
    },

    maxFreeRateNum() {
      if (!this.isHbfq) {
        return;
      }

      const { fq_free_rate_nums } = this.productInfo.pay_info;
      return fq_free_rate_nums && fq_free_rate_nums.length
        ? Math.max(...fq_free_rate_nums)
        : 0;
    },

    maxFqNum() {
      if (!this.isHbfq) {
        return;
      }

      const { hb_fq_nums } = this.productInfo.pay_info;
      return hb_fq_nums && hb_fq_nums.length ? Math.max(...hb_fq_nums) : 0;
    },

    hbfqTip() {
      if (!this.isHbfq) {
        return;
      }

      if (this.maxFreeRateNum) {
        return this.maxFreeRateNum + "期免手续费";
      }

      return;
    },
  },
  methods: {
    setLevel(value) {
      this.level = value
    },
    termPrice(num) {
      if (!this.isHbfq) {
        return;
      }

      let { real_price } = this.productInfo;
      const {
        support_hb_fq,
        fq_free_rate_nums,
        hb_fq_nums,
        hb_fq_rate,
        hb_fq_seller_percent,
      } = this.productInfo.pay_info;
      if (num < 3) {
        return;
      }

      let price = Math.floor(real_price / num);
      return price < 1 ? real_price : price;
    },

    feePrice(num) {
      if (!this.isHbfq) {
        return;
      }

      let { real_price } = this.productInfo;
      const {
        support_hb_fq,
        fq_free_rate_nums,
        hb_fq_nums,
        hb_fq_rate,
        hb_fq_seller_percent,
      } = this.productInfo.pay_info;
      let rate = hb_fq_rate[num];

      //如果分期有free
      if (
        fq_free_rate_nums.find((e) => {
          return e == num;
        })
      ) {
        rate = 0;
      }

      if (hb_fq_seller_percent == 100) {
        rate = 0;
      }

      let totalFee = roundHalfEven(real_price * rate);
      let fee = Math.floor(totalFee / num);
      return fee;
    },

    changeHbfqNum(num) {
      this.payMode = "hbfq";
      this.selectedHbfqNum = num;
    },

    changePayMode(payMode) {
      this.payMode = payMode;

      if (payMode == "hbfq" && this.selectedHbfqNum == 0) {
        const { hb_fq_nums } = this.productInfo.pay_info;
        if (hb_fq_nums && hb_fq_nums.length > 0) {
          this.selectedHbfqNum = hb_fq_nums[0];
        }
      }
    },

    // 获取商品信息
    getProductInfo() {
      ProductApi.getProductDetail({
        series_number: this.productId,
      }).then((res) => {
        const { related_products } = res.data;

        if (
          related_products &&
          related_products[0] &&
          related_products[0].expand_course_type === 14
        ) {
          // 观鱼书画商品
          // 更改为观鱼书画的用户协议
          this.lawUrl =
            "https://sc2.hexiaoxiang.com/hx_wxapp_fish/gysh_law.html";
          this.lawLabel = "观鱼书画院用户服务协议";
        }

        this.productInfo = res.data;
        document.title = res.data.title
        // 判断是否有实物商品
        for (let i in related_products) {
          if (!related_products[i].is_virtual) {
            this.needAddress = true;
            if (related_products[i].expand_course_type === 1) {
              this.haveHardPen = true;
            }
          }
        }
        this.getUserAddressInfo();
        !this.$route.query.payMode && this.changePayMode("wxPay");
        this.$route.query.payMode == "hbfq" && this.changePayMode("hbfq");
      });
    },
    // 调起微信原生编辑收货地址
    editAddress() {
      getWxLocation(this.setAddress);
    },
    // 设置收货地址
    setAddress(res) {
      const {
        userName,
        provinceName,
        cityName,
        countryName,
        detailInfo,
        telNumber,
      } = res;
      const { gid } = this.userInfo;
      const data = {
        name: userName,
        address: `${provinceName}-${cityName}-${countryName}-${detailInfo}`,
        cellphone: telNumber,
      };
      gid ? (data.gid = gid) : "";
      this.userInfo = {
        ...this.userInfo,
        ...data,
      };
    },
    submitAddress() {
      if (this.needAddress) {
        if (this.level === 0 && this.haveHardPen) {
          this.$toast("请选择课程级别");
          return;
        }
        if (
          (typeof this.child_nn !== "string" || this.child_nn.length === 0) &&
          this.haveHardPen
        ) {
          this.$toast("请输入孩子名");
          return;
        }
        if (!this.userInfo.address) {
          this.$toast("请设置收货地址");
          return;
        }
      } else {
        const phoneRegex = /^(1[0-9]{10})$/;
        if (!phoneRegex.test(this.userInfo.cellphone)) {
          this.$toast("请输入正确手机号");
        }
      }
      // 判断用户是否勾选了协议
      if (!this.isAgreement) {
        this.$toast(`请勾选${this.lawLabel}`);
        return;
      }
      if (this.userInfo.gid && this.needAddress) {
        UserApi.editAddress(this.userInfo).then((res) => {
          this.startCreateOrder();
        });
      } else if (this.needAddress) {
        UserApi.addAddress(this.userInfo).then((res) => {
          this.startCreateOrder();
        });
      } else {
        this.startCreateOrder();
      }
    },
    // 获取用户地址信息
    getUserAddressInfo() {
      UserApi.getAddress().then((res) => {
        this.userInfo = res.data;
      });
    },
    // 创建订单
    startCreateOrder() {
      const hard_pen_info = {};
      const logistics_code_map = {};
      const { related_products, title } = this.productInfo;
      const skuList = [];
      related_products.forEach((v) => {
        if (!v.is_virtual) {
          // 商品物流列表
          logistics_code_map[v.gid + ""] =
            typeof this.logisticsList[v.expand_course_type] == "string"
              ? this.logisticsList[v.expand_course_type]
              : this.logisticsList[v.expand_course_type][this.level];
        }
        if (v.expand_course_type === 1) {
          if (!v.is_virtual) {
            hard_pen_info[v.gid + ""] = {
              logisitics_code: this.logisticsList[1][this.level],
              child_name: this.child_nn,
            }; // 硬笔课程物流信息列表
          }
        }
        skuList.push([v.expand_course_type, v.duration]); // 硬笔课程规格列表
      });
      // 这里说明调用的不是微信支付 用的是支付宝支付
      const tmpParams = {
        assemble_product_series_number: this.productId,
        assemble_product_name: title,
        platform: 1,
        note: this.note,
        refer_source: localStorage.getItem("staffId"),
        hard_pen_info,
        skuList,
        logistics_code_map,
      };
      if (this.$route.query.shareId) {
        tmpParams.shareId = this.$route.query.shareId;
      }
      OrderApi.createOrder(tmpParams).then((res) => {
        this.createOrderId = res.data.out_trade_no;
        // 支付宝支付流程
        this.createOrderId = res.data.out_trade_no;
        // 支付宝支付流程
        if (this.payMode == "aliPay" || this.payMode == "hbfq") {
          this.$router.push(
            `/goOther?out_trade_no=${this.createOrderId}&payMode=${this.payMode}&hbfq_num=${this.selectedHbfqNum}&productId=${this.productId}&key=${this.$store.state.key}&title=${title}`
          );
          return;
        } else if (this.payMode == "wxPay") {
          wxPay
            .pay({
              out_trade_no: this.createOrderId,
              subject: title || "河小象",
            })
            .then((res) => {
              res && wexinPay(res, this.paySuc, this.payError); // 微信SDK支付
            });
        } else {
          this.$toast("请选择支付方式!");
          return;
        }
      });
    },
    // 获取微信支付凭证
    getWxPayData() {
      OrderApi.getWxPayInfo({
        out_trade_no: this.createOrderId,
        trade_type: "JSAPI",
        app_id: "wx05d995b24ad77759",
        attach: "crm_related_order",
      }).then((res) => {
        wexinPay(res.data, this.paySuc, this.payError); // 微信SDK支付
      });
    },
    // 支付成功
    paySuc() {
      OrderApi.getOrderStatus({
        out_trade_no: this.createOrderId,
      })
        .then((res) => {
          if (res.data.trade_state === 1) {
            this.$router.replace({
              name: "paySuc",
              query: {
                productId: this.productId,
              },
            });
          }
        })
        .catch((res) => {
          this.paySuc();
        });
    },
    payError() {
      this.$toast("支付失败, 请重试");
    },
    goAgreement() {
      const { child_nn, level } = this;
      localStorage.setItem(
        "form",
        JSON.stringify({
          child_nn,
          level,
        })
      );
      window.location.href = this.lawUrl;
    },
  },
  filters: {
    priceFilter(val) {
      return val ? "￥" + val / 100 : "";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../style/mixin.scss";

.create-contain {
  width: 100%;
  .product-info {
    display: flex;
    box-sizing: border-box;
    padding: 15px 19px;
    width: 100%;
    background: white;
    .product-pic {
      border-radius: 8px;
      width: 86px;
      height: 86px;
    }
    .product-info-context {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 15px;
      width: 234px;
      height: 86px;
      line-height: 21px;
      font-size: 15px;
      color: #2d2e3f;
      .product-title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
  }
  .blank-line {
    width: 100%;
    height: 10px;
    background: #f0f0f5;
  }

  .info-line {
    box-sizing: border-box;
    padding: 15px 15px 0px;
    width: 100%;
    background: white;

    .product-detail {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .img {
        width: 52px;
        height: 52px;
        margin-right: 10px;
        border-radius: 6px;
      }
      .info {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        .title {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #3c3531;
          margin-bottom: 2px;
          height: 20px;
          display: flex;
          align-items: center;
        }
        .subtitle {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 12px;
          color: #a7a4a1;
          margin-top: 2px;
          height: 17px;
          display: flex;
          align-items: center;
        }
      }
      .price {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #3c3531;
        letter-spacing: 0;
      }
    }

    .info-title-line {
      display: flex;
      align-items: flex-end;

      .info-line-title {
        height: 25px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        font-weight: 500;
        color: #3c3531;
        display: flex;
        align-items: flex-end;
      }
      .info-line-tip {
        margin-left: 7px;
        font-weight: 400;
        font-size: 13px;
        color: #8a8e99;
        display: flex;
        align-items: flex-end;
      }
    }
    .address-info {
      margin-top: 7px;
      box-sizing: border-box;
      width: 100%;
      min-height: 82px;
      display: flex;
      @include verticalCenter;
      .address-info-content {
        @include fontBase(13px, 400, rgba(45, 46, 63, 1), 19px);
        flex-grow: 1;
        padding-right: 15px;
        .address-info-content-top {
          margin-bottom: 5px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 16px;
          color: #3c3531;
        }
        .address-info-content-bottom {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #726e6b;
        }
      }
      .address-info-line {
        width: 1px;
        height: 48px;
        background: rgba(216, 216, 216, 1);
        flex-shrink: 0;
      }
      .address-info-btn {
        @include fontBase(13px, 400, rgba(252, 155, 48, 1), 19px);
        flex-shrink: 0;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        width: 63px;
        padding-left: 25px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #9e531d;
      }
    }
    .new-address {
      display: flex;
      align-items: center;
      justify-content: center;      
      box-sizing: border-box;
      height: 82px;
      margin-top: 6px;
      .address-btn {
        width: 95px;
      }
    }
    .note-input {
      margin-top: 8px;
      border-radius: 8px;
      width: 335px;
      background: rgba(245, 245, 247, 1);
    }

    .input-line {
      display: flex;
      align-items: center;
      padding: 18px 0;
      box-sizing: border-box;
      .level-select {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #3C3531;
        letter-spacing: 0;
        margin-left: 25px;
        flex-grow: 1;
      }
      .level-arrow {
        width: 16px;
        height: 16px;
      }
      .input-label {
        line-height: 21px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #726e6b;
      }
      .input-label-short {
        margin-right: 0;
      }
      .long-input {
        width: 251px;
      }
      .short-input {
        margin-right: 20px;
        width: 130px;
        background: rgba(245, 245, 247, 1);
      }
      .code-btn {
        width: 101px;
        height: 37px;
        line-height: 37px;
        background: #fe693f;
        font-size: 12px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .price-detail { 
    padding-bottom: 15px;   
    .price-line {
      margin-top: 15px;    
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 20px;
      align-items: center;
      .price-title {       
        font-size: 14px;
        color: #726E6B;
      }
      .price {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #3C3531;
      }
      .price-num {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 18px;
        color: #F46111;
      }
    }
  }
  .page-contain-bottom {
    width: 100vw;
    height: 77px;
  }
  .page-bottom1 {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    bottom: 76px;
    width: 100vw;
    height: 38px;
    background: #fffae7;
    img {
      width: 18px;
      height: 18px;
    }
    & > .img-box {
      height: 100%;
      width: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & > span {
      display: inline-block;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 13px;
      color: #9e531d;
      text-decoration: underline;
      opacity: 1;
      line-height: 29px;
      padding-left: 10px;
    }
  }
  .page-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.08);
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 76px;
    background: white;
    padding: 0px 10px 10px 20px;
    box-sizing: border-box;
    .bottom-price {
      font-size: 28px;
      font-family: Resource-Han-Rounded-CN-Bold, Resource-Han-Rounded-CN;
      font-weight: bold;
      color: #ff7b4c;
      line-height: 40px;
    }
    .pay-btn {
      width: 172px;
      height: 56px;
      background: #ffd70a;
      border-radius: 28px;
      font-size: 18px;
      font-family: Resource-Han-Rounded-CN-Bold, Resource-Han-Rounded-CN;
      font-weight: bold;
      color: #9e531d;
      line-height: 26px;
    }
  }
}
// /deep/ .van-dropdown-menu {
//   width: 250px;
//   height: 36px;
// }

.pay {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  background: #ffffff;
  .check {
    width: 24px;
    height: 24px;
    margin-right: 4px;
  }
  .uncheck {
    width: 24px;
    height: 24px;
    background: #ffffff;
    border-radius: 24px;
    border: 1px solid #aeacaa;
    box-sizing: border-box;
    margin-right: 4px;
  }
  .wx-icon {
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }
  .title {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #3c3531;
    letter-spacing: 0;

    .hbfq-tip {
      font-size: 14px;
      font-family: Resource-Han-Rounded-CN-Medium, Resource-Han-Rounded-CN;
      font-weight: 500;
      color: #ff7b4c;
      line-height: 22px;
    }
  }
  .left {
    display: flex;
    align-items: center;
  }
}

.pay + .pay::before {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 0px;
  top: 0;
  left: 0px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  -ms-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.huabei {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0px 0px 8px 0px;
  justify-content: space-between;
  align-content: space-between;
  height: 147px;  
  .huabei-item:first-child {
    margin-bottom: 9px;
  }

  .huabei-item {
    background: #f5f5f5;
    border-radius: 10px;
    width: 43.5vw;
    height: 69px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    position: relative;

    span {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #726E6B;
      height: 17px;
      margin-top: 2px;
    }

    .price {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #3C3531;
      height: 20px;
    }
    .recommend {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 17px;
      height: 16px;
    }
  }

  .active {
    background: #FFFAE7;
    border-radius: 10px;
    border: 1px solid #F8CF00;    
  }
}

.bottom-border {
  height: 1px;
  width: 100%;
  flex-shrink: 0;
  background-color: #ebedf0;
  box-shadow: inset 0 0 0 0 #e6e6e6;
}

.input-line /deep/ .van-dropdown-menu {
  width: 250px;
  height: 36px;
}
.input-line /deep/ .van-dropdown-menu__bar {
  width: 250px;
  height: 36px;
}
/deep/ .van-dropdown-menu__item {
  justify-content: flex-start !important;
  padding-left: 10px;
  background: #f5f5f7;
  .van-dropdown-menu__title {
    min-width: 220px;
  }
}
/deep/ .van-ellipsis {
  color: rgb(195, 195, 195);
}
/deep/ .van-field {
  padding: 0 25px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #a7a4a1;
  /deep/ .van-cell__value {
    display: flex;
    align-items: center;
  }
}
.note-input /deep/ .van-field__control {
  width: 600px;
}
/deep/ .van-field__control::-webkit-input-placeholder {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #a7a4a1;
}
</style>